

















































































import {
  defineComponent,
  ref,
  Ref,
  computed,
  watch,
  onMounted,
} from '@vue/composition-api';
import { AkkadianLetterGroupsUpper } from '@oare/oare';
import { DictionarySearchRow } from '@oare/types';
import ResultTable from '../components/ResultTable.vue';
import DictionarySearchInfoCard from './components/DictionarySearchInfoCard.vue';
import { highlightedItem } from '../utils';
import useQueryParam from '@/hooks/useQueryParam';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'DictionarySearch',
  components: {
    ResultTable,
    DictionarySearchInfoCard,
  },
  setup() {
    const totalResults = ref(0);
    const searchResults: Ref<DictionarySearchRow[]> = ref([]);
    const searchLoading = ref(false);
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const dictionarySearch = useQueryParam('dictionary', '', true);
    const page = useQueryParam('page', '1', false);
    const rows = useQueryParam('rows', '25', true);
    const mode = useQueryParam('mode', 'matchWholeWords', true);
    const types = ref(['word', 'PN', 'GN']);
    const typeLabels = [
      { label: 'Words', value: 'word' },
      { label: 'Names', value: 'PN' },
      { label: 'Places', value: 'GN' },
    ];
    const useMode = ref(mode.value);
    const lastSearch = ref('');
    const canSearch = computed(() => {
      return dictionarySearch.value.trim() !== '';
    });
    const headers = ref([
      {
        text: 'Word',
        value: 'name',
      },
      {
        text: 'Translations',
        value: 'translations',
      },
      {
        text: 'Forms and Spellings',
        value: 'matches',
      },
    ]);

    const performSearch = async () => {
      if (canSearch.value) {
        searchLoading.value = true;
        lastSearch.value = dictionarySearch.value;
        try {
          const searchResult = await server.searchDictionary({
            search: dictionarySearch.value,
            page: Number(page.value),
            rows: Number(rows.value),
            mode: useMode.value,
            types: types.value,
          });
          totalResults.value = searchResult.totalRows;
          searchResults.value = searchResult.results;
        } catch (err) {
          actions.showErrorSnackbar(
            'Error performing dictionary search. Please try again.',
            err as Error
          );
        } finally {
          searchLoading.value = false;
        }
      }
    };

    const enableModeSelection = computed(() => {
      return !dictionarySearch.value.includes('-');
    });

    const resetSearch = () => {
      page.value = '1';
      performSearch();
    };

    onMounted(performSearch);

    watch([page, rows], performSearch, { immediate: false });

    const wordLink = (word: DictionarySearchRow) => {
      if (word.type === 'word') {
        return `/dictionaryWord/${word.uuid}`;
      } else if (word.type === 'PN') {
        return `/namesWord/${word.uuid}`;
      } else if (word.type === 'GN') {
        return `/placesWord/${word.uuid}`;
      }
      return null;
    };

    const getItemTranslations = (item: DictionarySearchRow) => {
      return item.translations;
    };

    const getItemMatches = (item: DictionarySearchRow) => {
      return item.matches;
    };

    return {
      dictionarySearch,
      canSearch,
      totalResults,
      searchResults,
      performSearch,
      highlightedItem,
      searchLoading,
      page,
      rows,
      headers,
      lastSearch,
      wordLink,
      resetSearch,
      getItemTranslations,
      getItemMatches,
      enableModeSelection,
      useMode,
      types,
      typeLabels,
    };
  },
});
